module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.klass.gap,
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "input",
    class: _vm.klass.input,
    style: ({
      width: _vm.baseWidth + _vm.charLen(_vm.text) + 'ch'
    }),
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.text)
    },
    on: {
      "mousedown": _vm.preventNativeActive,
      "blur": _vm.finishEditing,
      "keydown": _vm.keyPress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.typing) ? _vm._t("default") : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5643ad75!./~/vue-loader/lib/selector.js?type=template&index=0!./src/typing.vue
// module id = 21
// module chunks = 0